import CreateTaskDialog from "@/components/CreateTask/createTaskDialog.component";
import TaskSearchBox from "@/components/SearchContainer/taskSearchBox.component";
import TaskTimer from "@/components/TaskTimer/taskTimer.component";
import { ROUTE_LOGIN_OUT, ROUTE_PROFILE } from "@/constants/routes.constants";
import { AppContext } from "@/services/AppContext/appContext";
import { useTheme } from "@/shadcn/components/theme-provider";
import { Button } from "@/shadcn/components/ui/button";
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuList,
  NavigationMenuTrigger,
} from "@/shadcn/components/ui/navigation-menu";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/shadcn/components/ui/tooltip";
import {
  DatabaseZap,
  LogOut,
  Moon,
  Plus,
  Sun,
  Unlock,
  User,
} from "lucide-react";
import React, { useContext } from "react";
import { useNavigate } from "react-router";

const Navbar: React.FC = () => {
  const { user, isLockedAnimation, forceFetchAll, stopTimer } =
    useContext(AppContext);
  const { theme, setTheme } = useTheme();
  const nav = useNavigate();

  return (
    <div className="flex-none w-full flex items-center justify-between p-2  dark:bg-gray-700 bg-primary text-white relative z-20 pr-0">
      <div className="flex items-center justify-center">
        <div className="mr-2 font-medium hidden md:block">SuperCharged</div>
        <CreateTaskDialog>
          <div>
            <Button
              variant={theme === "light" ? "secondary" : "default"}
              className={`rounded-full items-center justify-center lg:hidden`}
              size={"icon"}
            >
              <Plus className="h-5" />
            </Button>
            <Button
              variant={theme === "light" ? "secondary" : "default"}
              className={`rounded-full items-center justify-center hidden lg:flex`}
            >
              <span className="mr-1">Create</span>
              <Plus className="h-5" />
            </Button>
          </div>
        </CreateTaskDialog>
      </div>
      <div className="relative">
        <TaskSearchBox />
      </div>
      <div className="flex items-center justify-center">
        <TaskTimer type={{ location: "navbar" }} />
        <div className="cursor-pointer mr-0 hidden lg:block">
          {theme === "dark" ? (
            <Sun onClick={() => setTheme("light")} />
          ) : (
            <Moon onClick={() => setTheme("dark")} />
          )}
        </div>
        <div>
          <NavigationMenu dropdownAlign="right">
            <NavigationMenuList>
              <NavigationMenuItem className="">
                <NavigationMenuTrigger
                  className="!bg-transparent pr-0 !text-white"
                  dropdownIcon="left"
                >
                  {isLockedAnimation && (
                    <span className="absolute flex size-2 top-1 right-2">
                      <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-sky-400 opacity-75"></span>
                      <span className="relative inline-flex size-2 rounded-full bg-sky-500"></span>
                    </span>
                  )}
                  {user.profile_picture ? (
                    <img
                      key={"navbarProfile"}
                      src={user.profile_picture}
                      alt="profile"
                      className="rounded-full w-8 h-8 content-center cursor-pointer mr-2"
                    />
                  ) : (
                    <div className="rounded-full cursor-pointer w-8 h-8 overflow-hidden bg-primary flex items-center justify-center shadow mr-2">
                      <User className="" />
                    </div>
                  )}
                </NavigationMenuTrigger>
                <NavigationMenuContent className="dark:bg-gray-800 overflow-hidden max-w-[150px]">
                  <div className="flex flex-col w-full gap-3 p-3">
                    <span className="text-sm font-semibold">
                      {user.first_name} {user.surname}
                    </span>
                    <div className="cursor-pointer mr-0 lg:hidden flex items-center justify-center">
                      {theme === "dark" ? (
                        <Sun onClick={() => setTheme("light")} />
                      ) : (
                        <Moon onClick={() => setTheme("dark")} />
                      )}
                    </div>
                    <TaskTimer type={{ location: "navbar-dropdown" }} />
                    <TooltipProvider>
                      <Tooltip delayDuration={100}>
                        <TooltipTrigger asChild>
                          <Button
                            className="flex flex-row flex-nowrap items-center justify-start truncate"
                            size="sm"
                            onClick={async () => {
                              forceFetchAll();
                            }}
                          >
                            <DatabaseZap className="mr-1" />
                            Clear Precache
                          </Button>
                        </TooltipTrigger>
                        <TooltipContent side="left">
                          Clear all the precached data and refetch it from the
                          server
                        </TooltipContent>
                      </Tooltip>
                    </TooltipProvider>

                    <Button
                      className="flex flex-row flex-nowrap items-center justify-start truncate"
                      size="sm"
                      onClick={async () => {
                        stopTimer();
                      }}
                    >
                      <Unlock className="mr-1" />
                      Sync Timer
                    </Button>
                    <Button
                      className="flex flex-row flex-nowrap items-center justify-start"
                      size="sm"
                      onClick={() => {
                        nav(ROUTE_PROFILE);
                      }}
                    >
                      <User className="mr-1" />
                      Profile
                    </Button>
                    <Button
                      className="flex flex-row flex-nowrap items-center justify-start"
                      size="sm"
                      onClick={() => {
                        nav(ROUTE_LOGIN_OUT);
                      }}
                    >
                      <LogOut className="mr-1" />
                      Logout
                    </Button>
                  </div>
                </NavigationMenuContent>
              </NavigationMenuItem>
            </NavigationMenuList>
          </NavigationMenu>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
